import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { Header, InputSelect, NavHeader } from '../../../../../../components';
import { Page } from '../../../../../../components/page';
import { TariffName } from '../../../channel-details/optimizer/configuration/types/tariff-kind';
import { operatorLogos } from '../../../channel-details/optimizer/configuration/utils/tariff-kind';
import { ChartDynamic } from '../../../common/tariff/charts-presentation/chart-dynamic';
import { ChartG11 } from '../../../common/tariff/charts-presentation/chart-g11';
import { ChartG13s } from '../../../common/tariff/charts-presentation/chart-g13s';
import { ChartTariff } from '../../../common/tariff/charts-presentation/chart-tariff';
import { useTariffs } from '../../hooks/use-tariffs';

const TariffOverview: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { tariff, tariffs, tariffData, operator, handleTariffChange } = useTariffs();
  const operatorData = operatorLogos.find((x) => x.operator === operator);

  const renderCurrentPrentation = () => {
    if (!tariff) return null;

    if (tariff === TariffName.Dynamic) return <ChartDynamic />;
    if (tariff === TariffName.G13S) return <ChartG13s />;
    if (tariff === TariffName.G11) return <ChartG11 />;
    return <ChartTariff {...tariffData} tariffName={tariff} />;
  };

  return (
    <Page
      isStickyHeader
      containerClassName="p-t-0 p-l-0 p-r-0 p-b-0"
      contentClassName="page__content page__content--flex"
      header={
        <>
          <NavHeader />
          <Header title={`${t('tariffs.header')} ${operatorData?.name || ''}`} />
        </>
      }
    >
      <Box sx={{ backgroundColor: 'var(--color-element)', padding: 3, flex: 1 }} className="max-width-desktop">
        <InputSelect
          label={t('tariff.tariff')}
          value={tariff || undefined}
          onChange={handleTariffChange}
          options={tariffs}
          reverse
        />
        {renderCurrentPrentation()}
      </Box>
    </Page>
  );
};

export default TariffOverview;
